<template>
  <!--==================
    component shows packages management & rearrangement for operator (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <!-- start of packages management -->
    <div v-if="management" class="card">
      <input
        class="form-control mb-4"
        placeholder="Search by id"
        v-model="keyword"
        type="number"
        style="max-width: 300px"
      />
      <div class="table-responsive">
        <table class="table table-sm table-nowrap card-table">
          <thead class="text-primary">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>PRICE</th>
              <th>DAYS</th>
              <th>TITLE</th>
              <th>TYPE</th>
              <th>TAG SETTING</th>
              <th>TAG SHOW</th>
              <th>Discount SHOW</th>
              <th>Logo SHOW</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!filteredPackageById.length" class="text-center">
              <td colspan="4">
                <span class="text-muted"><em>Data not found for this operator</em></span>
              </td>
            </tr>
            <tr v-for="(tour, index) in filteredPackageById" :key="tour.id">
              <td :id="'row-' + tour.id">
                {{ tour.position }}
              </td>
              <td class="text-right" style="max-width: 100px; overflow-wrap: break-word">{{ tour.id }}</td>
              <td class="text-right">{{ tour.price | currency }}</td>
              <td class="text-right">{{ tour.noOfDay }}</td>
              <td class="font-weight-bold" style="width: 500px; min-width: 500px; white-space: pre-wrap">
                <a class="d-block p-3" :href="packageUrl + tour.id" target="_blank">{{ tour.title }}</a>
              </td>
              <td>{{ tour.tourGroup }}, {{ tour.level }}</td>
              <td>
                <select
                  @change="tagSelect($event)"
                  class="form-control form-control-sm"
                  :value="tour.tag"
                  :data-id="tour.id"
                >
                  <option value="">-none-</option>
                  <option value="seller">Best Seller</option>
                  <option value="offer">Best Offer</option>
                  <option value="review">Best Review</option>
                  <option value="rated">Top Rated</option>
                </select>
              </td>
              <td>
                <select
                  v-if="tour.cardDetails != undefined"
                  @change="tag($event)"
                  class="form-control form-control-sm"
                  :value="tour.cardDetails.showTag"
                  :data-id="tour.id"
                >
                  <option value="true">SHOW</option>
                  <option value="false">HIDE</option>
                </select>
              </td>
              <td>
                <select
                  v-if="tour.cardDetails != undefined"
                  @change="tag($event)"
                  class="form-control form-control-sm"
                  :value="tour.cardDetails.showDiscountIcon"
                  :data-id="tour.id"
                >
                  <option value="true">SHOW</option>
                  <option value="false">HIDE</option>
                </select>
              </td>
              <td>
                <select
                  v-if="tour.cardDetails != undefined"
                  @change="tag($event)"
                  class="form-control form-control-sm"
                  :value="tour.cardDetails.showOperatorLogo"
                  :data-id="tour.id"
                >
                  <option value="true">SHOW</option>
                  <option value="false">HIDE</option>
                </select>
              </td>
              <td class="text-right">
                <button
                  @click="inactiveStatus($event)"
                  class="btn btn-sm btn-success mr-2"
                  :data-id="tour.id"
                  :data-index="index"
                >
                  Inactive
                </button>
                <button @click="edit($event)" class="btn btn-sm btn-primary ml-2 mr-2" :data-id="tour.id">Edit</button>
                <button
                  @click="unpublishStatus($event)"
                  class="btn btn-sm btn-danger mr-2"
                  :data-id="tour.id"
                  :data-index="index"
                >
                  Unpublish
                </button>
                <button
                  @click="remove($event)"
                  class="btn btn-sm btn-danger ml-2"
                  :data-id="tour.id"
                  :data-index="index"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- end of packages management -->

    <!-- start of packages rearrangement -->
    <div v-if="rearrangement" class="card">
      <input
        class="form-control mb-4"
        placeholder="Search by id"
        v-model="keyword"
        type="number"
        style="max-width: 300px"
      />
      <div class="table-responsive">
        <table id="table-package" class="table table-sm table-nowrap card-table">
          <thead class="text-primary">
            <tr>
              <th>Position</th>
              <th>TOUR ID</th>
              <th>TOUR PRICE</th>
              <th>TOUR DAYS</th>
              <th>TOUR TITLE</th>
              <th>TOUR TYPE</th>
              <th>TOUR SPECIALIZED</th>
              <th>MAIN DESTINATION</th>
              <th>ACTIVITY & DESTINATION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!filteredPackageById.length" class="text-center">
              <td colspan="4">
                <span class="text-muted"><em>Data not found for this operator</em></span>
              </td>
            </tr>
            <tr v-for="tour in filteredPackageById" :key="tour.id" :data-position="tour.position" :data-id="tour.id">
              <td :id="'row-' + tour.id">
                <input
                  type="text"
                  class="form-control"
                  v-model="tour.position"
                  @change="updatePosition(tour.id, $event)"
                  style="width: 70px"
                />
              </td>
              <td class="text-right">{{ tour.id }}</td>
              <td class="text-right">{{ tour.price | currency }}</td>
              <td class="text-right">{{ tour.noOfDay }}</td>
              <td class="font-weight-bold">
                <a class="d-block p-3" :href="packageUrl + tour.id" target="_blank">{{ tour.title }}</a>
              </td>
              <td>{{ tour.tourGroup }}, {{ tour.level }}</td>
              <td>{{ tour.tourFocus.name }}</td>
              <td>{{ tour.mainDestination }}</td>
              <td :title="tour.activityDestination">{{ tour.subActivityDestination }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- end of packages rearrangement -->
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OperatorPackage",

  data() {
    return {
      management: false,
      rearrangement: false,
      filteredPackageById: [],
      keyword: "",
    };
  },

  watch: {
    keyword: function () {
      if (this.keyword && this.packages != undefined) {
        this.filteredPackageById = this.packages.filter((item) => {
          return item.id == this.keyword;
        });
      } else {
        this.filteredPackageById = this.packages;
      }
    },
  },

  computed: {
    ...mapGetters(["publishedOperatorPackages"]),

    packages() {
      return this.filterTourPackages(this.publishedOperatorPackages);
    },

    packageUrl() {
      return process.env.VUE_APP_PACKAGE_URL;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      const action = this.$route.query.act;
      const operator = this.$route.params.id;

      this.actionPackages(action);

      await this.fetchPublishedOperatorPackages(operator);
      this.hideBarLoading();
      this.filteredPackageById = this.packages;
    });
  },

  methods: {
    ...mapActions([
      "fetchPublishedOperatorPackages",
      "deletePackage",
      "publishPackage",
      "updatePackageStatus",
      "hideBarLoading",
      "updatePackageIcon",
      "updatePackageTag",
      "updatePackagePosition",
    ]),

    async inactiveStatus(e) {
      const operator = this.$route.params.id;
      const id = e.target.getAttribute("data-id");

      await this.updatePackageStatus({ id, status: 0 });
      this.fetchPublishedOperatorPackages(operator);
    },

    async unpublishStatus(e) {
      const operator = this.$route.params.id;
      const id = e.target.getAttribute("data-id");

      await this.publishPackage({ id, publish: false });
      this.fetchPublishedOperatorPackages(operator);
    },

    remove(e) {
      const operator = this.$route.params.id;
      const id = e.target.getAttribute("data-id");
      const dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this package?",
        buttons: {
          confirm: async () => {
            await dP.deletePackage(id);
            dP.fetchPublishedOperatorPackages(operator);
          },
          cancel: () => {},
        },
      });
    },

    edit(e) {
      const id = e.target.getAttribute("data-id");

      window.open("/dashboard/tour/edit/" + id, "_blank");
    },

    filterTourPackages(tourPackages) {
      tourPackages.forEach((tour) => {
        // set tour price
        if (tour.rates.adult.length) {
          tour["price"] = tour.rates.adult[0].currencyWinter;
        } else {
          tour["price"] = 0;
        }

        // set tour level
        tour["level"] = tour.levels.join(", ");

        // set main destination
        if (tour.otherActivity) {
          tour["mainDestination"] = tour.otherActivity.name;
        } else {
          tour["mainDestination"] = "-";
        }

        // set activity destination
        tour["activityDestination"] = tour.activities
          .map((item) => {
            return item.name;
          })
          .join(", ");

        // set sub activity destination
        tour["subActivityDestination"] = tour.activityDestination.split(",").splice(0, 3).join(", ");
      });

      return tourPackages;
    },

    actionPackages(action) {
      if (action == "management") {
        this.management = true;
      } else if (action == "rearrangement") {
        this.rearrangement = true;
      }
    },

    tag(e) {
      let id = e.target.getAttribute("data-id");

      var element = $(`select[data-id=${id}]`);

      let tag = element[1].value;
      let discount = element[2].value;
      let logo = element[3].value;

      var data = {
        id: id,
        tag: tag,
        discount: discount,
        logo: logo,
      };
      this.updatePackageIcon(data);
    },

    tagSelect(e) {
      let id = e.target.getAttribute("data-id");
      var element = $(`select[data-id=${id}]`);
      let tag = element[0].value;
      var data = { id: id, tag: tag };
      this.updatePackageTag(data);
    },

    async updatePosition(id, e) {
      var positions = [
        {
          id: id,
          position: e.target.value,
        },
      ];
      const operator = this.$route.params.id;
      await this.updatePackagePosition(positions);
      this.fetchPublishedOperatorPackages(operator);
    },
  },
};
</script>
